import React from "react";
import ProjectSquare from "./MobileProjectSquare";
import images from "../../data/projectImages.js"

const MobileProjects = () => {
  return (
    <div className="flex flex-col justify-center items-center p-8 pt-0">
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 place-items-center justify-center gap-y-6 w-full p-2">
        <ProjectSquare
          imageUrl={images["105West1st"][0]}
          name="105 West 1st Street"
          loc="Boston, MA"
        />
        <ProjectSquare
          imageUrl={images["888Boylston"][0]}
          name="888 Boylston Street"
          loc="Boston, MA"
        />
        <ProjectSquare
          imageUrl={images["BostonMed"][0]}
          name="Boston Medical"
          loc="Boston, MA"
        />
        <ProjectSquare
          imageUrl={images["BUDentalSchool"][0]}
          name="Boston University School of Dental Medicine"
          loc="Boston, MA"
        />
        <ProjectSquare
          imageUrl={images["BulfinchCrossing"][0]}
          name="Bulfinch Crossing"
          loc="Boston, MA"
        />
        <ProjectSquare
          imageUrl={images["Eataly"][0]}
          name="Eataly"
          loc="Boston, MA"
        />
        <ProjectSquare
          imageUrl={images["MassMutualFanPier"][0]}
          name="Mass Mutual @ Fan Pier"
          loc="Boston, MA"
        />
        <ProjectSquare
          imageUrl={images["Pier4"][0]}
          name="Pier 4"
          loc="Boston, MA"
        />
        <ProjectSquare
          imageUrl={images["22Liberty"][0]}
          name="Twenty Two Liberty @ Fan Pier"
          loc="Boston, MA"
        />
        <ProjectSquare
          imageUrl={images["105West1st"][0]}
          name="150 2nd Street"
          loc="Cambridge, MA"
        />
        <ProjectSquare
          imageUrl={images["GoogleHQ"][0]}
          name="Google Headquarters"
          loc="Cambridge, MA"
        />
        <ProjectSquare
          imageUrl={images["MITSite5"][0]}
          name="MIT Site 5"
          loc="Cambridge, MA"
        />
        <ProjectSquare
          imageUrl={images["RagonInstituteII"][0]}
          name="Ragon Institute II"
          loc="Cambridge, MA"
        />
        <ProjectSquare
          imageUrl={images["URIEngn"][0]}
          name="URI College of Engineering"
          loc="South Kingston, RI"
        />
        <ProjectSquare
          imageUrl={images["DanburyHospital"][0]}
          name="Danbury Hospital"
          loc="Danbury, CT"
        />
        <ProjectSquare
          imageUrl={images["QuinnipiacAcademic"][0]}
          name="Quinnipiac University Academic Building"
          loc="Hamden, CT"
        />
        <ProjectSquare
          imageUrl={images["QuinnipiacBusiness"][0]}
          name="Quinnipiac University School of Business"
          loc="Hamden, CT"
        />
        <ProjectSquare
          imageUrl={images["QuinnipiacWellness"][0]}
          name="Quinnipiac University Wellness Center"
          loc="Hamden, CT"
        />
        <ProjectSquare
          imageUrl={images["Foxwoods"][0]}
          name="Foxwoods Resort Hotel & Casino"
          loc="Ledyard, CT"
        />
        <ProjectSquare
          imageUrl={images["MGM"][0]}
          name="MGM Grand at Foxwoods"
          loc="Ledyard, CT"
        />
        <ProjectSquare
          imageUrl={images["100College"][0]}
          name="100 College St"
          loc="New Haven, CT"
        />
        <ProjectSquare
          imageUrl={images["101College"][0]}
          name="101 College St"
          loc="New Haven, CT"
        />
        <ProjectSquare
          imageUrl={images["55Park"][0]}
          name="55 Park Street"
          loc="New Haven, CT"
        />
        <ProjectSquare
          imageUrl={images["Knights"][0]}
          name="Knights of Columbus"
          loc="New Haven, CT"
        />
        <ProjectSquare
          imageUrl={images["YalePeabody"][0]}
          name="Yale Peabody Museum"
          loc="New Haven, CT"
        />
        <ProjectSquare
          imageUrl={images["YaleSmilow"][0]}
          name="Yale Smilow Cancer Center"
          loc="New Haven, CT"
        />
        <ProjectSquare
          imageUrl={images["NorwalkHospital"][0]}
          name="Norwalk Hospital"
          loc="Norwalk, CT"
        />
        <ProjectSquare
          imageUrl={images["BrownEngn"][0]}
          name="Brown University School of Engineering"
          loc="Providence, RI"
        />
        <ProjectSquare
          imageUrl={images["PCFriarCenter"][0]}
          name="Providence College Friar Center"
          loc="Providence, RI"
        />
        <ProjectSquare
          imageUrl={images["PCNursingSchool"][0]}
          name="Providence College School of Nursing"
          loc="Providence, RI"
        />
        <ProjectSquare
          imageUrl={images["PCBusinessSchool"][0]}
          name="Providence College School of Business"
          loc="Providence, RI"
        />
        <ProjectSquare
          imageUrl={images["ProvidencePlace"][0]}
          name="Providence Place Mall"
          loc="Providence, RI"
        />
        <ProjectSquare
          imageUrl={images["SouthStreetLanding"][0]}
          name="South Street Landing"
          loc="Providence, RI"
        />
        <ProjectSquare
          imageUrl={images["DunkinDonutsCenter"][0]}
          name="The Dunkin' Donuts Center"
          loc="Providence, RI"
        />
        <ProjectSquare
          imageUrl={images["BryantBelloCenter"][0]}
          name="Bryant University George E. Bello Center"
          loc="Smithfield, RI"
        />
        <ProjectSquare
          imageUrl={images["StamfordHospital"][0]}
          name="Stamford Hospital"
          loc="Stamford, CT"
        />
        <ProjectSquare
          imageUrl={images["UCONNGant"][0]}
          name="UCONN Gant Renovation"
          loc="Storrs, CT"
        />
        <ProjectSquare
          imageUrl={images["UCONNStem"][0]}
          name="UCONN Stem Research Center"
          loc="Storrs, CT"
        />
        <ProjectSquare
          imageUrl={images["MoheganSunEarth"][0]}
          name="Mohegan Sun Earth Hotel"
          loc="Uncasville, CT"
        />
        <ProjectSquare
          imageUrl={"/timeline/mohegan_sun_new.webp"}
          name="Mohegan Sun Tower Hotel"
          loc="Uncasville, CT"
        />
        <ProjectSquare
          imageUrl={images["WhitePlains"][0]}
          name="White Plains Hospital Medical Center"
          loc="White Plains, NY"
        />
        <ProjectSquare
          imageUrl={images["BrighamWomens"][0]}
          name="Brigham & Women's Faulkner Hospital Tower"
          loc="Boston, MA"
        />
        <ProjectSquare
          imageUrl={images["BrighamWomens"][0]}
          name="Brigham & Women's Faulkner Hospital Garage"
          loc="Boston, MA"
        />
        <ProjectSquare
          imageUrl={images["ParcelG"][0]}
          name="Parcel G"
          loc="Cambridge, MA"
        />
        <ProjectSquare
          imageUrl={images["BrighamWomens"][0]}
          name="Yale BCT"
          loc="New Haven, CT"
        />
        <ProjectSquare
          imageUrl={images["BrighamWomens"][0]}
          name="Volpe Department of Transportation"
          loc="Cambridge, MA"
        />
        <ProjectSquare
          imageUrl={images["PrudentialCenter"][0]}
          name="Prudential Center"
          loc="Boston, MA"
        />
        <ProjectSquare
          imageUrl={images["YaleKline"][0]}
          name="Yale Kline Tower"
          loc="New Haven, CT"
        />
        <ProjectSquare
          imageUrl={images["SHUHockey"][0]}
          name="Sacred Heart University Hockey Arena"
          loc="Fairfield, CT"
        />
        <ProjectSquare
          imageUrl={images["BrighamWomens"][0]}
          name="Sacred Heart University North Dorm"
          loc="Fairfield, CT"
        />
        <ProjectSquare
          imageUrl={images["SHUSeton"][0]}
          name="Sacred Heart University Seton Hall Dorm"
          loc="Fairfield, CT"
        />
        <ProjectSquare
          imageUrl={images["SHUMerton"][0]}
          name="Sacred Heart University Merton Hall Dorm"
          loc="Fairfield, CT"
        />
        <ProjectSquare
          imageUrl={images["UMassNERB"][0]}
          name="UMass Medical School NERB"
          loc="Worcester, MA"
        />
      </div>
    </div>
  );
};

export default MobileProjects;
